import React from 'react'
import './Article.css'
import ArticleCard from './ArticleCard'
import {services} from '../../constants'
import img1 from '../../assets/businessman-with-tie.png'
import img2 from '../../assets/building.png'
import {service_article} from "../../constants/service_article";
export default function Article() {
    const articles = service_article.map( (art,index) => <ArticleCard img={index == 0 ? img1 : img2} article={art} />)
    return (
        <div className='article'>
            <h1 className={"heading_section"}>{services.title}</h1>
            <div className="grid">
                {articles}
            </div>
        </div>
    )
}
